import React, { createContext, useContext, useState } from 'react';

const ReviewContext = createContext(null);

export const ReviewProvider = ({ children }) => {
    const [isReviewing, setIsReviewing] = useState(false);
    const [applicationStatus, setApplicationStatus] = useState(null);
    const [reviewerProfileData, setReviewerProfileData] = useState({ name: '', email: '' });

    const value = {
        isReviewing,
        setIsReviewing,
        applicationStatus,
        setApplicationStatus,
        reviewerProfileData,
        setReviewerProfileData,
        shouldBlockNavigation: isReviewing && (applicationStatus === 'PENDING' || applicationStatus === 'IN_REVIEW')
    };

    return (
        <ReviewContext.Provider value={value}>
            {children}
        </ReviewContext.Provider>
    );
};

export const useReviewContext = () => {
    const context = useContext(ReviewContext);
    if (!context) {
        throw new Error('useReviewContext must be used within ReviewProvider');
    }
    return context;
};